export enum UserProfileRole {
  student = 'student',
  ta = 'ta',
  instructor = 'instructor',
  author = 'author',
  editor = 'editor',
  corre = 'corre',
  admin = 'admin',
}
